import { render, staticRenderFns } from "./PassengersDashboard.vue?vue&type=template&id=355e5804&scoped=true"
import script from "./PassengersDashboard.vue?vue&type=script&lang=js"
export * from "./PassengersDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e5804",
  null
  
)

export default component.exports